module.exports = __webpack_public_path__ + "static/media/app-store-logo-150x150.a44b454f.png";